<mat-toolbar class="lms-mat-toolbar">
    <img [src]="companyLogo" alt="Company Logo" class="lms-company-logo">
    <span style="margin-left: 10px;cursor: pointer;" (click)="navigateToDashboard()">{{ offsetWidth <= 900 ?
            companyShortName : companyName}}</span>
            <span class="example-spacer"></span>
            <div class="search-container" *ngIf="menuList.length > 0">
                <input class="search-input" type="search" aria-label="search" placeholder="Go to page"
                    (focus)="isOpen = true" (keyup)="onKeyUpForSearching($event.target.value)"
                    (search)="closeCancelButton($event)">
                <div class="search-results" *ngIf="isOpen">
                    <ul class="menues">
                        <li (click)="isOpen = false">
                            <div class="top-search-bar">
                                <div class="search-navigation-label">Select menu to navigate</div>
                                <button mat-icon-button [disableRipple]="true">
                                    <div aria-label="clear" class="lms-cancel-icon"></div>
                                </button>
                            </div>
                        </li>
                        <li *ngFor="let menu of cloneMenuList" class="menu">
                            <div class="inner" (click)="redirectToSelectedMenu(menu.url)">
                                <span>{{ menu.menuName }}</span>
                            </div>
                        </li>

                        <li *ngIf="cloneMenuList.length === 0" class="menu">
                            <div class="search-navigation-label" style="text-align: center;">No menu found...</div>
                        </li>
                    </ul>
                </div>
            </div>
            <button mat-icon-button [disableRipple]="true" (click)="showNotificationBlock = !showNotificationBlock">
                <div aria-label="notification" class="lms-notification-icon"></div>
                <span class="notification-count">{{notificationList$.getValue().length === 0 ? null :
                    notificationList$.getValue().length > 9 ? '9+' :
                    notificationList$.getValue().length}}</span>
            </button>
            <div class="notification-container" *ngIf="showNotificationBlock">
                <div class="notification-title">
                    <h3>Notifications</h3>
                    <div aria-label="mark-all-icon" class="lms-mark-all-icon"> </div>
                </div>

                <div class="notification-messages"
                    *ngIf="notificationList$.getValue().length > 0; else emptyNotificationBlock">
                    <div *ngFor="let notification of notificationList$ | async; let index = index"
                        class="notification-item">
                        <div class="row"
                            style="align-items: center;cursor: pointer;margin-left: -8px;margin-right: -8px;">
                            <div class="col-1" (click)="onClickOfNotification(notification , index)">
                                <div aria-label="clear-notification-icon" class="lms-clear-notification-icon"></div>
                            </div>
                            <div class="col-11">
                                <div class="notification" [id]="'size_' + index">
                                    {{notification.message}}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <ng-template #emptyNotificationBlock>
                    <div class="no-notification-found">You have not received any notification.</div>
                </ng-template>

                <div class="notification-actions">
                    <button mat-raised-button class="view-all" *ngIf="notificationList$.getValue().length > 0"
                        (click)="trackAllNotification()">View all
                        notifications</button>
                    <button mat-raised-button class="clear-all" *ngIf="notificationList$.getValue().length > 0"
                        (click)="readAllMessages()">Clear all</button>
                </div>
            </div>
            <button mat-icon-button [matMenuTriggerFor]="menu" class="myMenuItem" [disableRipple]="true">
                <img [src]="imageURL" class="lms-profileimage-icon" alt="Profile Image" height="30">
            </button>
            <mat-menu #menu="matMenu" class="myMenu">
                <span mat-menu-item style="text-align: center;">
                    Welcome <b>{{userName}}</b>
                </span>
                <button mat-menu-item class="myMenuItem" (click)="changePassword()">
                    <div aria-label="changepassword" class="lms-changepassword-icon"></div>
                    <span>Change Password</span>
                </button>
                <button mat-menu-item class="myMenuItem" (click)="logout()">
                    <div aria-label="logout" class="lms-logout-icon"></div>
                    <span>Logout</span>
                </button>
            </mat-menu>

</mat-toolbar>